/** Shared scan resolution / compression settings (scan.html mirrors these). */
export const SCAN_STRAIGHTEN_MAX_PX = 4000;
export const SCAN_JPEG_QUALITY = 0.96;
export const SCAN_PHONE_GALLERY_MAX_PX = 4096;
export const SCAN_PHONE_CAMERA_IDEAL_PX = 3840;
